"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("@studio/constants");
var _utils = require("../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Creates a scene where all the sources are displayed,
 * but where none have more emphasis/focus than
 * the other (i.e. all sources have the same size)
 * @param {Array} sources
 * @param {{}} sourceStyle
 */

function gridBuilder(sources) {
  var sourceStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var TILE_MARGIN = 20;
  var camSources = (0, _utils.getCameraSources)(sources);
  return {
    // TODO: remove as it is unnecessary and unused and probably will be confused w/ mongo object IDs
    _id: 'sceneGrid',
    style: _objectSpread({}, _utils.COMMON_SCENE_STYLES),
    title: _constants.GRID.title,
    description: _constants.GRID.title,
    layers: camSources.map(function (source, sourceIndex) {
      var sourceNum = sourceIndex + 1;
      var topSceneMargin = _utils.SCENE_HEIGHT * 40 / 378;
      var leftSceneMargin = _utils.SCENE_WIDTH * 40 / 672;
      var camSourceCount = Math.min(camSources.length, _utils.MAX_CAMERA_COUNT);
      var tileStyles = {};
      var availableWidth = _utils.SCENE_WIDTH - leftSceneMargin * 2;
      var availableHeight = _utils.SCENE_HEIGHT - topSceneMargin * 2;
      var bannerValues;
      var horizontalPadding;
      if (camSourceCount === 1) {
        tileStyles = {
          top: topSceneMargin,
          left: leftSceneMargin,
          width: availableWidth,
          height: availableHeight
        };
        // Per UX request, horizontal padding is adjusted for smoother transition to 2+ speakers on stage in grid layout.
        horizontalPadding = 1.5;
      } else {
        var gridConfig = _utils.gridConfigMap[camSourceCount];
        // Dimension adjustment to allow tile/scene margins
        availableHeight = availableHeight - TILE_MARGIN;
        availableWidth = availableWidth - TILE_MARGIN * (gridConfig.row1Count - 1);

        // Tile dimensions
        var tileWidth = availableWidth / gridConfig.row1Count;
        var tileHeight = camSourceCount < 3 ? availableHeight : availableHeight / 2;

        // Current item row state
        var isRow1 = sourceNum <= gridConfig.row1Count;
        var isRowStart = sourceNum === 1 || gridConfig.row1Count + 1 === sourceNum;

        // Tile/scene margins
        var topTileMargin = isRow1 ? 0 : TILE_MARGIN;
        var rightTileMargin = isRow1 ? TILE_MARGIN * sourceIndex : TILE_MARGIN * (sourceIndex - gridConfig.row1Count);

        // Tile offsets
        var row1MediaOffset = sourceIndex * tileWidth;
        var row2LeftOffset = (availableWidth - tileWidth * gridConfig.row2Count) / 2;
        var row2MediaOffset = (sourceIndex - gridConfig.row1Count) * tileWidth + row2LeftOffset;
        var topMediaOffset = isRow1 ? 0 : tileHeight;
        var leftMediaOffset = isRowStart ? isRow1 ? 0 : row2LeftOffset : isRow1 ? row1MediaOffset : row2MediaOffset;

        // Tile specific styles
        tileStyles = {
          width: tileWidth,
          height: tileHeight,
          top: topMediaOffset + topSceneMargin + topTileMargin,
          left: leftMediaOffset + leftSceneMargin + rightTileMargin
        };
      }

      // Camera counts of 1 or 2 are the only grid configurations that have a single speaker row.
      // Position namecards to overlap: 12% of video feed for single row layouts, 16% for multi-row layouts
      bannerValues = camSourceCount < 3 ? (0, _utils.getSmallBannerLayout)(tileStyles.height, tileStyles.top) : (0, _utils.getLargeBannerLayout)(tileStyles.height, tileStyles.top);
      var _bannerValues = bannerValues,
        bannerHeight = _bannerValues.bannerHeight,
        bannerTop = _bannerValues.bannerTop;
      var bannerPosition = (0, _utils.getPresenterBannerPosition)(tileStyles);
      var _getDynamicTitleStyle = (0, _utils.getDynamicTitleStyles)(bannerHeight),
        titleHeight = _getDynamicTitleStyle.titleHeight,
        subTitleHeight = _getDynamicTitleStyle.subTitleHeight,
        subTitleGap = _getDynamicTitleStyle.subTitleGap;
      var titleFontSize = camSourceCount > 2 ? 22 : 33;
      var subTitleFontSize = camSourceCount > 2 ? 17 : 25;
      return {
        _id: source._id,
        source: source,
        layer: {
          animation: _objectSpread(_objectSpread({}, _utils.HARD_CUT_ANIMATION), {}, {
            animate: _objectSpread(_objectSpread({}, _utils.HARD_CUT_ANIMATION.animate), {}, {
              top: tileStyles.top,
              left: tileStyles.left,
              width: tileStyles.width,
              height: tileStyles.height
            })
          }),
          style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _utils.COMMON_CAMERA_STYLES.styles), {}, {
            top: 0,
            left: 0,
            zIndex: sourceNum,
            position: 'absolute',
            mediaStyle: _objectSpread(_objectSpread({}, _utils.COMMON_CAMERA_STYLES.mediaStyles), {}, {
              objectFit: 'cover',
              width: tileStyles.width,
              height: tileStyles.height
            })
          }, tileStyles), sourceStyle), {}, {
            bannerStyles: _objectSpread(_objectSpread(_objectSpread({}, bannerPosition), _utils.extraPresenterBannerStyles), {}, {
              zIndex: sourceNum
            }, (0, _utils.getDynamicBannerStyles)(bannerHeight, titleHeight, subTitleHeight, subTitleGap, titleFontSize, subTitleFontSize, horizontalPadding)),
            bannerAnimation: _objectSpread(_objectSpread({}, _utils.PRESENTER_BANNER_ANIMATION), {}, {
              animate: _objectSpread(_objectSpread({}, _utils.PRESENTER_BANNER_ANIMATION.animate), {}, {
                left: bannerPosition.left,
                top: bannerTop
              })
            })
          })
        }
      };
    })
  };
}
var _default = exports["default"] = gridBuilder;